import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const DEEP_LINK_SCHEME = 'barguide';

export function MobileCallbackPage() {
  const [searchParams] = useSearchParams();
  const [showFallback, setShowFallback] = useState(false);

  const deepLinkUrl = `${DEEP_LINK_SCHEME}://auth/callback?${searchParams.toString()}`;

  useEffect(() => {
    // Attempt to redirect to the native app
    window.location.href = deepLinkUrl;

    // Show fallback after a short delay (deep link may have failed)
    const timer = setTimeout(() => {
      setShowFallback(true);
    }, 1500);

    return () => clearTimeout(timer);
  }, [deepLinkUrl]);

  const handleOpenApp = () => {
    window.location.href = deepLinkUrl;
  };

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        {!showFallback ? (
          <>
            <div className="animate-spin w-8 h-8 border-2 border-amber-500 border-t-transparent rounded-full mx-auto mb-4" />
            <p className="text-zinc-400">Opening Bar Guide...</p>
          </>
        ) : (
          <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-6">
            <h1 className="text-xl font-semibold text-white mb-2">
              Open in Bar Guide
            </h1>
            <p className="text-zinc-400 text-sm mb-6">
              Tap the button below to complete sign-in in the Bar Guide app.
            </p>
            <button
              onClick={handleOpenApp}
              className="w-full bg-amber-500 hover:bg-amber-600 text-black font-medium py-3 px-4 rounded-lg transition-colors"
            >
              Open Bar Guide
            </button>
            <p className="text-zinc-500 text-xs mt-4">
              Don't have the app?{' '}
              <a
                href="https://barguide.ai"
                className="text-amber-500 hover:text-amber-400"
              >
                Download it here
              </a>
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
